import React, { useState,useRef ,useEffect} from "react";
import { Empty, Button,Checkbox,Select,Input,DatePicker,Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "./superuserTableSelectable.scss";
import useSuperUserInfoStore from "../../store/superuser.store";
import { Document, Page, pdfjs } from 'react-pdf';

export default function SuperUserTableSelectable({
    isClickable = false,
    titleList,
    data,
    extraData,
    isEditField = false,
    currentView
}) {
  const navigate = useNavigate();
  // Requiring the module
  const moment = require('moment');
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const { updateSuperUserDocumentStatus,updateSuperUserSubsStatus,updateSuperUserFreeStatus,fetchUserDoc,userVerificationFile,superUserInfo,superAdminInfo } = useSuperUserInfoStore();

  const convertDateToTS = (date) => {
        if (date) {
            return moment(date, 'YYYY.MM.DD', true).startOf('day').unix();
        } else {
            return "";
        }
    };
  useEffect(() => {

    const checkBoxArray = data?.map((item,idx) => {
      return {
        updatetype: "",
        selected: false,
        status: "",  //this is new status
        startdate:item.startdate,
        startdateTS:convertDateToTS(item.startdate),
        trialperiod:item.trialperiod,
        duration:item.duration,
        enddate:item.enddate,
        enddateTS:convertDateToTS(item.enddate),
        ndiscount:item.ndiscount,
        rdiscount:item.rdiscount,
        finalprice:item.finalprice,
        planamount:item.planamount,
        subid:item.subID
      };
    });
    setCheckBoxData(checkBoxArray);
  }, [data]);

const [isModalVisible, setIsModalVisible] = useState(false);
const [numPages, setNumPages] = useState(null);

const viewDocument = (email) => {
    const ownerid = superUserInfo.adminstats?.find(admin => admin.email === email)?.companyid;
    fetchUserDoc(ownerid,"1");
    setIsModalVisible(true);
};

const handleModalClose = () => {
    setIsModalVisible(false);
    setNumPages(null);
};

const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    //console.log('PDF loaded successfully, total pages:', numPages);
};

  const ResetCheckBox = () => {
    var checkBoxResetArray = checkBoxData?.map((item,idx) => {
      return {
        updatetype: "",
        selected: false,
        status: "", //this is new status
        startdate:item.startdate,
        startdateTS:item.startdateTS,
        enddate:item.enddate,
        enddateTS:item.enddateTS,
        trialperiod:item.trailperiod,
        duration:item.duration,
        ndiscount:item.ndiscount,
        rdiscount:item.rdiscount,
        finalprice:item.finalprice,
        planamount:item.planamount,
        subid:item.subID
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };

    if (!data) {
        return <Empty style={{ margin: "60px" }} />;
    }

    function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData.length; idx++){    
            if (checkBoxData[idx].selected ) {
                return true
            } 
        }
        return false
    }
    const onCheckBoxChange = (e) => {
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true;    
        }else{
            checkBoxData[e.target.value].selected = false; 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }

    const trialStatusStateMachine = (rowIndex) =>{
        var statusDropDown

        if (data?.[rowIndex]?.trialstatus == "trial_inactive") {
            statusDropDown= [
                { value: rowIndex + '#' +'trial_activation_in_progress', label: 'ACTIVATE' },
                { value: rowIndex + '#' +'trial_stop', label: 'STOP' },
            ]   
        }else if (data?.[rowIndex]?.trialstatus == "trial_activation_in_progress") {
            statusDropDown= [
               { value: rowIndex + '#' +'trial_stop', label: 'STOP' },
            ] 
        }else if (data?.[rowIndex]?.trialstatus == "trial_active") {
            statusDropDown= [
               { value: rowIndex + '#' +'trial_stop', label: 'STOP' },
            ] 
        }else if (data?.[rowIndex]?.trialstatus == "trial_expired") {
            statusDropDown= [
                { value: rowIndex + '#' +'trial_activation_in_progress', label: 'ACTIVATE' },
            ]   
        }else if (data?.[rowIndex]?.trialstatus == "trial_stop") {
            statusDropDown= [
                { value: rowIndex + '#' +'trial_activation_in_progress', label: 'ACTIVATE' },
            ]   
        }

        console.log("Trial Status",data?.[rowIndex]?.trialstatus);
        return statusDropDown
    }

    const subStatusStateMachine = (rowIndex) =>{
        var statusDropDown

        if (data?.[rowIndex]?.substatus == "subscription_inactive") {
            statusDropDown= [
                { value: rowIndex + '#' +'subscription_configured', label: 'CONFIGURED' },
            ]   
        }else if (data?.[rowIndex]?.substatus == "subscription_configured") {
            statusDropDown= [
                { value: rowIndex + '#' +'subscription_activation_in_progress', label: 'ACTIVATE' },
            ]   
        }else if (data?.[rowIndex]?.substatus == "subscription_activation_in_progress IN PROGRESS") {
            statusDropDown= [
               { value: rowIndex + '#' +'subscription_stopped', label: 'STOP' },
            ] 
        }else if (data?.[rowIndex]?.substatus == "subscription_active") {
            statusDropDown= [
               { value: rowIndex + '#' +'subscription_stopped', label: 'STOP' },
            ] 
        }
        //console.log("Sub Status",data?.[rowIndex]?.substatus);
        return statusDropDown
    }

    const paymentStatusStateMachine = (rowIndex) =>{
        var statusDropDown

        if (data?.[rowIndex]?.paymentstatus == "payment_none") {
            statusDropDown= [
                { value: rowIndex + '#' +'payment_req', label: 'REQUEST PAYMENT' },
            ]   
        }else if (data?.[rowIndex]?.paymentstatus == "payment_revise") {
            statusDropDown= [
                { value: rowIndex + '#' +'payment_req', label: 'REQUEST PAYMENT' },
            ]   
        }
        //console.log("payment Status",data?.[rowIndex]?.paymentstatus);
        return statusDropDown
    }

    const OnSelectChangeDocStatus = (value) => {
        const answer_array = value.split('#');
        var status = answer_array[1]
        var idx = answer_array[0]
        var idxInt = parseInt(idx)
        const updatedValues = [...checkBoxData];
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["updatetype"]: "DOCUMENT_STATUS" };
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["status"]: status };
        setCheckBoxData(updatedValues);
    }
    const OnSelectChangeTrialStatus = (value) => {
        const answer_array = value.split('#');
        var status = answer_array[1]
        var idx = answer_array[0]
        var idxInt = parseInt(idx) 
        const updatedValues = [...checkBoxData];
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["updatetype"]: "FREE_STATUS" };
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["status"]: status };
        setCheckBoxData(updatedValues);
    }

    const OnSelectChangeSubStatus = (value) => {
        const answer_array = value.split('#');
        var status = answer_array[1]
        var idx = answer_array[0]
        var idxInt = parseInt(idx)
        const updatedValues = [...checkBoxData];
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["updatetype"]: "SUBSCRIPTION_STATUS" };
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["status"]: status };
        setCheckBoxData(updatedValues);
    }
    const OnSelectChangePaymentStatus = (value) => {
        const answer_array = value.split('#');
        var status = answer_array[1]
        var idx = answer_array[0]
        var idxInt = parseInt(idx) 

        const updatedValues = [...checkBoxData];
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["updatetype"]: "PAYMENT_STATUS" };
        updatedValues[idxInt] = { ...updatedValues[idxInt], ["status"]: status };
        setCheckBoxData(updatedValues);
    }
    const getTrialStatus =(status)=>{
        if(status === "trial_none"){return "-"}
        if(status === "trial_inactive"){return "INACTIVE"}
        if(status === "trial_active"){return "ACTIVE"}
        if(status === "trial_expired"){return "EXPIRED"}   
        if(status === "trial_stop"){return "STOP"}
        if(status === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}
        if(status === "trial_expired"){return "EXPIRED"}     
    } 

    const getSubscriptionStatus =(status)=>{
        if(status === "subscription_none"){return "NONE"}
        if(status === "subscription_inactive"){return "INACTIVE"}
        if(status === "subscription_new_req"){return "NEW REQ "}
        if(status === "subscription_configured"){return "CONFIGURED"}
        if(status === "subscription_active"){return "ACTIVE"}
        if(status === "subscription_expired"){return "EXPIRED"}
        if(status === "subscription_stopped"){return "STOPPED"} 
        if(status === "subscription_aborted"){return "ABORTED"} 
        if(status === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}
    } 

    const getDocumentStatus =(status)=>{
        if(status === "doc_verification_pending"){return "PENDING"}
        if(status === "doc_rejected"){return "REJECTED"}
        if(status === "doc_verified"){return "VERIFIED"}       
    }

   const getPaymentStatus =(status)=>{
        if(status === "payment_none"){return "NA"}
        if(status === "payment_req"){return "REQUEST PAYMENT"}
        if(status === "payment_revise"){return "REVISE PAYMENT"} 
        if(status === "payment_declined"){return "DECLINED PAYMENT"}
        if(status === "payment_done"){return "PAYMENT DONE"}        
    }

    const getAccountStatus =(status)=>{
        if(status === "account_created"){return "ACCOUNT CREATED"}
        if(status === "signup_otp_verification_pending"){return "VERIFICATION PENDING"}
        if(status === "signup_account_verified"){return "VERIFIED"}
        if(status === "account_deleted"){return "ACCOUNT DELETED"}
        if(status === "account_suspended"){return "ACCOUNT SUSPENDED"}           
    }     
    const handleChange = (event, index) => {
        const { name, value } = event.target;
        const updatedValues = [...checkBoxData];
        updatedValues[index] = { ...updatedValues[index], [name]: value };
        //console.log("handle change", index, name, value)

        var sDate = checkBoxData[index].startdate
        if((sDate != null)&&(sDate!="")){
                       
            var unixTimestamp = moment(sDate).unix();

            var endDateTimeStamp = unixTimestamp + value * 24 * 60 * 60
            updatedValues[index] = { ...updatedValues[index], ["enddateTS"]: endDateTimeStamp };

            const enddate = new Date(endDateTimeStamp * 1000);
            updatedValues[index] = { ...updatedValues[index], ["enddate"]: moment(enddate).format('YYYY.MM.DD') };
            //console.log("Unix Timestamp date2", index, unixTimestamp, moment(enddate).format('YYYY.MM.DD'))
            //console.log("Duration Change Startdate EndDate Duration", event,enddate,checkBoxData[index].trialperiod )
        }else{
            updatedValues[index] = { ...updatedValues[index], ["enddate"]: "" };
        } 

        setCheckBoxData(updatedValues);
    };
    const handleChangeDate = (event, index) => {
        //const { name, value } = event.target;
        var name = "startdate"

        const dateFormat = 'YYYY/MM/DD';
        const month = event?.$M+1;
        const year = event?.$y;
        const date = event?.$D;
        const value = year + " " + month + " " + date;

        const updatedValues = [...checkBoxData];
        updatedValues[index] = { ...updatedValues[index], [name]: event };
        if(event != null){
            var unixTimestamp = moment(value).unix();
            updatedValues[index] = { ...updatedValues[index], ["startdateTS"]: unixTimestamp };

            var endDateTimeStamp = unixTimestamp + checkBoxData[index].trialperiod * 24 * 60 * 60
            if(currentView === "paid"){
                //console.log(`selected ${value}`);
                const answer_array = checkBoxData[index].duration.split(' ')
                var months = answer_array[1]
                var duration = parseInt(answer_array[0])
                endDateTimeStamp = unixTimestamp + duration * 30 * 24 * 60 * 60
                //console.log("UComaing here", endDateTimeStamp, unixTimestamp)
            }
            updatedValues[index] = { ...updatedValues[index], ["enddateTS"]: endDateTimeStamp };
            const enddate = new Date(endDateTimeStamp * 1000);
            updatedValues[index] = { ...updatedValues[index], ["enddate"]: moment(enddate).format('YYYY.MM.DD') };
            //console.log("Unix Timestamp date3", index, unixTimestamp, moment(enddate).format('YYYY.MM.DD'))
        }else{
            updatedValues[index] = { ...updatedValues[index], ["enddate"]: "" };
        } 

        setCheckBoxData(updatedValues);
    };

    
    const handleChangeDiscount = (event, index) => {
        const { name, value } = event.target;
        const updatedValues = [...checkBoxData];
        updatedValues[index] = { ...updatedValues[index], [name]: value };

        //update final price
        var finalPrice = checkBoxData[index].planamount
        if(name === "rdiscount"){
            finalPrice = finalPrice - (finalPrice*value/100) - ((finalPrice*checkBoxData[index].ndiscount/100))
        }else if (name =="ndiscount"){
            finalPrice = finalPrice - (finalPrice*value/100) - ((finalPrice*checkBoxData[index].rdiscount/100))
        }
        
        finalPrice = Math.floor(finalPrice)
        updatedValues[index] = { ...updatedValues[index], "finalprice": finalPrice };

        //console.log("handleChangeDiscount",updatedValues, event.target)
        setCheckBoxData(updatedValues);
    };
    const handlePaymentStatus = (event, index) => {
        const { name, value } = event.target;
        const updatedValues = [...checkBoxData];
        updatedValues[index] = { ...updatedValues[index], [name]: value };
        setCheckBoxData(updatedValues);
    };

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }
    const encodeJson = (updateType) =>{

        let encodedJsonValues ={};
        
        //get company details
        encodedJsonValues._id="Not used"
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type ;


        //now fill the parameters
        encodedJsonValues.documentlist =[];
        encodedJsonValues.subslist =[];
        encodedJsonValues.freelist =[];
        
        var num=0
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx])
            if (checkBoxData[idx].selected && updateType =="DOCUMENT_STATUS" ) {
                encodedJsonValues.documentlist[num]={};
                encodedJsonValues.documentlist[num].newstatus =checkBoxData[idx].status;
                encodedJsonValues.documentlist[num].name =data[idx].name;
                encodedJsonValues.documentlist[num].qhoid =extraData[data[idx].id-1].qhoid; 
                num++;
            } 

            if (checkBoxData[idx].selected && updateType =="SUBSCRIPTION_STATUS" ) {
                encodedJsonValues.subslist[num]={};
                encodedJsonValues.subslist[num].name =data[idx].name;
                encodedJsonValues.subslist[num].qhoid =extraData?.[data[idx].id-1].qhoid; 
                encodedJsonValues.subslist[num].subid =extraData[data[idx].id-1].subID; 

                //data which changes
                encodedJsonValues.subslist[num].startdate =checkBoxData[idx].startdateTS; 
                encodedJsonValues.subslist[num].duration = parseInt(checkBoxData[idx].duration); 
                encodedJsonValues.subslist[num].enddate =checkBoxData[idx].enddateTS; 
                encodedJsonValues.subslist[num].ndiscount =checkBoxData[idx].ndiscount; 
                encodedJsonValues.subslist[num].rdiscount =checkBoxData[idx].rdiscount; 
                encodedJsonValues.subslist[num].finalprice =checkBoxData[idx].finalprice; 
                if(checkBoxData[idx].status == ""){
                    encodedJsonValues.subslist[num].newstatus =data[idx].subscriptionstatus; 
                }else{
                    encodedJsonValues.subslist[num].newstatus =checkBoxData[idx].status;
                }
                
                encodedJsonValues.subslist[num].planamount =checkBoxData[idx].planamount; 
                encodedJsonValues.subslist[num].currentstatus =data[idx].subscriptionstatus; 
                encodedJsonValues.subslist[num].planname =data[idx].planname; 

                num++;
            }
            if (checkBoxData[idx].selected && updateType =="FREE_STATUS" ) {
                encodedJsonValues.freelist[num]={};
                if(checkBoxData[idx].status == ""){
                    encodedJsonValues.freelist[num].newstatus =data[idx].trialstatus;
                }else{
                    encodedJsonValues.freelist[num].newstatus = checkBoxData[idx].status;
                }
                
                encodedJsonValues.freelist[num].qhoid =extraData?.[data[idx].id-1].qhoid;
                encodedJsonValues.freelist[num].subid =extraData?.[data[idx].id-1].subID;
                encodedJsonValues.freelist[num].name =data[idx].name;
                encodedJsonValues.freelist[num].startdate =checkBoxData[idx].startdateTS; 
                encodedJsonValues.freelist[num].trialperiod = parseInt(checkBoxData[idx].trialperiod);
                encodedJsonValues.freelist[num].enddate =checkBoxData[idx].enddateTS; 
                encodedJsonValues.freelist[num].currentstatus =data[idx].trialstatus;
                encodedJsonValues.freelist[num].planname =data[idx].planname;  

                num++;
            }             
        }        
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatetype = updateType
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
             
        return encodedJsonValues
    }

    const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
    }
    const checkStatus=(rowIndex)=>{
        if(currentView == "free"){
            if(data?.[rowIndex]?.trialstatus === "trial_active")
                return false
        }else if (currentView == "paid"){
            if(data?.[rowIndex]?.substatus === "subscription_active")
                return false
        }
        return true
    }
    const checkPaymentStatus=(rowIndex)=>{
        if (currentView === "paid"){
            if(data?.[rowIndex]?.paymentstatus === "payment_done")
                return true
        }
        return false
    }
    const enableSubStatusChange=(rowIndex)=>{
        if (currentView === "paid"){
            if((data?.[rowIndex]?.paymentstatus === "payment_none")
                ||(data?.[rowIndex]?.paymentstatus === "payment_done"))
                return true
        }
        return false
    }

    const handleUpdateStatus = (value) => {
        var jasonValues= encodeJson("DOCUMENT_STATUS")
        //console.log("Document Json", jasonValues)
        updateSuperUserDocumentStatus({
            jasonValues
        });
        ResetCheckBox();
        setUpdateAvailable(false);
    }

    const handleUpdateStatusFree = (value) => {
        var jasonValues= encodeJson("FREE_STATUS")
        console.log("Free Json", jasonValues)
        updateSuperUserFreeStatus({
            jasonValues
        });
        ResetCheckBox();
        setUpdateAvailable(false);
    }
    const handleUpdateStatusPaid = (value) => {
        var jasonValues= encodeJson("SUBSCRIPTION_STATUS")
        console.log("Subscription Json", jasonValues)
        updateSuperUserSubsStatus({
            jasonValues
        });
        ResetCheckBox();
        setUpdateAvailable(false);
    }

    return (
        <div className="superusetable-selectable-wrapper">
            <div className="rtable-selectable-btn-wrapper"  >
                {currentView == "documents" ?
                <>
                    <Button
                        className="rtable-selectable-btn"
                        disabled={!updateAvailable}
                        onClick={handleUpdateStatus}
                    >
                    Update Status
                    </Button>                
                </>
                :<></>}
                {currentView == "free" ?
                <>
                    <Button
                        className="rtable-selectable-btn"
                        disabled={!updateAvailable}
                        onClick={handleUpdateStatusFree}
                    >
                    Save Changes
                    </Button>                
                </>
                :<></>}
                {currentView == "paid" ?
                <>
                    <Button
                        className="rtable-selectable-btn"
                        disabled={!updateAvailable}
                        onClick={handleUpdateStatusPaid}
                    >
                    Save Changes
                    </Button>                
                </>
                :<></>}                
            </div>
            <div
                className="rtable-title-wrapper"
                style={{
                    gridTemplateColumns: `50px 50px 5fr repeat(${titleList.length-3}, 5fr)`
                }}
            >
                {titleList.map((title) => (
                    <div className="superuser-table-title">{title}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    key={table.id}
                    className="rtable-info-wrapper"
                    style={{
                        gridTemplateColumns: `50px 50px 5fr repeat(${titleList.length-3}, 5fr)`,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="rtable-info">
                            {isEditField ? (
                                <div className="edit-field-wrapper">
                                        <>
                                            {tableInfo === "id"
                                                ? rowIndex + 1
                                                : <></>}
                                                
                                            {(tableInfo != "id") &&(tableInfo != "select")&&(tableInfo != "accountstatus")
                                             &&(tableInfo != "docstatus")&&(tableInfo != "trialstatus")
                                             &&(tableInfo != "enddate")&&(tableInfo != "startdate")
                                             &&(tableInfo != "trialperiod")&&(tableInfo != "substatus")
                                             &&(tableInfo != "ndiscount")&&(tableInfo != "finalprice") 
                                             &&(tableInfo != "rdiscount")&&(tableInfo != "paymentstatus")
                                             &&(tableInfo != "document")
                                                ? table[tableInfo]
                                                : <></>}

                                             { tableInfo === "select" ?
                                                <Checkbox value = {rowIndex} onChange={onCheckBoxChange}checked={getUpdated(rowIndex)}></Checkbox>
                                               : <></>
                                             }
                                             { tableInfo === "document" ?
                                                <Button 
                                                    type="text" 
                                                    style={{ padding: 0, height: 'auto', minHeight: 'auto' }}
                                                    onClick={() => {
                                                        viewDocument(table["aemail"])
                                                        // Add your click handler here
                                                        //console.log('Document clicked for row:', rowIndex);
                                                    }}
                                                >
                                                    👁️
                                                </Button>
                                               : <></>
                                             }
                                             { tableInfo === "docstatus" ? (
                                                    <>
                                                        {getUpdated(rowIndex) === true?

                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeDocStatus}
                                                            placeholder={getDocumentStatus(table[tableInfo])}                                                             
                                                            options={[
                                                                { value: rowIndex + '#' +'doc_rejected', label: 'DOCS REJECTED' },
                                                                { value: rowIndex + '#' +'doc_verified', label: 'DOCS VERIFIED' },
                                                            ]}
                                                        /> :
                                                        table[tableInfo]==""?"--":getDocumentStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               : <></>
                                             }                                           
                                             { tableInfo === "trialstatus" ? (
                                                    <>
                                                        {getUpdated(rowIndex) === true?

                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangeTrialStatus}
                                                            placeholder={getTrialStatus(table[tableInfo])}                                                             
                                                            options={trialStatusStateMachine(rowIndex)}
                                                        /> :
                                                        table[tableInfo]==""?"--":getTrialStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               : <></>
                                             } 
                                             { tableInfo === "accountstatus" ? (
                                                    <>
                                                        {table[tableInfo]==""?"--":getAccountStatus(table[tableInfo])
                                                       }    
                                                    </> 
                                               )                                             
                                               : <></>
                                             }                                              
                                             { tableInfo === "paymentstatus" ? (
                                                    <>
                                                        {getUpdated(rowIndex) === true?currentView=="payment"?
                                                        <Select
                                                            style={{ width: 130,height: 24 }}
                                                            onChange={OnSelectChangePaymentStatus}
                                                            placeholder={table[tableInfo]}                                                             
                                                            options={paymentStatusStateMachine(rowIndex)}
                                                        /> :table[tableInfo]==""?"--":getPaymentStatus(table[tableInfo]):
                                                        table[tableInfo]==""?"--":getPaymentStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               : <></>
                                             }                                              
                                             { tableInfo === "substatus" ?(
                                                    <>
                                                        {getUpdated(rowIndex) === true? enableSubStatusChange(rowIndex) ===true?

                                                        <Select
                                                            style={{ width: 150,height: 24 }}
                                                            onChange={OnSelectChangeSubStatus}
                                                            placeholder={table[tableInfo]}                                                             
                                                            options={subStatusStateMachine(rowIndex)}
                                                        /> :table[tableInfo]==""?"--":getSubscriptionStatus(table[tableInfo]):
                                                        table[tableInfo]==""?"--":getSubscriptionStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               :<></>
                                             } 
                                            {tableInfo === "ndiscount" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ? (
                                                <Input
                                                    style={{
                                                    width: 200,
                                                    height: 24,
                                                    textAlign: "center",
                                                    }}
                                                    name="ndiscount"
                                                    type ="number"
                                                    value={checkBoxData[rowIndex].ndiscount}
                                                    placeholder={checkBoxData[rowIndex].ndiscount}
                                                    onChange={(event) => handleChangeDiscount(event, rowIndex)}
                                                />
                                                ) : (
                                                table[tableInfo]
                                                )}
                                            </>
                                            ) : (
                                            <></>
                                            )}
                                            {tableInfo === "rdiscount" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ? (
                                                <Input
                                                    style={{
                                                    width: 200,
                                                    height: 24,
                                                    textAlign: "center",
                                                    }}
                                                    name="rdiscount"
                                                    type ="number"
                                                    value={checkBoxData[rowIndex].rdiscount}
                                                    placeholder={checkBoxData[rowIndex].rdiscount}
                                                    onChange={(event) => handleChangeDiscount(event, rowIndex)}
                                                />
                                                ) : (
                                                table[tableInfo]
                                                )}
                                            </>
                                            ) : (
                                            <></>
                                            )}                                            
                                            {tableInfo === "finalprice" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ? checkStatus(rowIndex)===true?(
                                                <>
                                                  {checkBoxData[rowIndex].finalprice}
                                                </>
                                                ) : (
                                                table[tableInfo]
                                                ):(
                                                    table[tableInfo]
                                                    )}
                                            </>
                                            ) : (
                                            <></>
                                            )}                                                                                           
                                            {tableInfo === "trialperiod" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ? (
                                                <Input
                                                    style={{
                                                    width: 200,
                                                    height: 24,
                                                    textAlign: "center",
                                                    }}
                                                    name="trialperiod"
                                                    type ="number"
                                                    value={checkBoxData[rowIndex].trialperiod}
                                                    placeholder={checkBoxData[rowIndex].trialperiod}
                                                    onChange={(event) => handleChange(event,rowIndex)}
                                                />
                                                ) : (
                                                table[tableInfo]
                                                )}
                                            </>
                                            ) : (
                                            <></>
                                            )} 
                                            {tableInfo === "startdate" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ?checkStatus(rowIndex)===true? (
                                                <DatePicker 
                                                    style={{
                                                    width: 200,
                                                    height: 24,
                                                    textAlign: "center",
                                                    }}
                                                    name="startdate"                                                    
                                                    placeholder={checkBoxData[rowIndex].startdate}
                                                    onChange={(event) => handleChangeDate(event, rowIndex)} />
                                                ) : (
                                                table[tableInfo]
                                                ):(table[tableInfo])}
                                            </>
                                            ) : (
                                            <></>
                                            )} 
                                            {tableInfo === "enddate" ? (
                                            <>
                                                {getUpdated(rowIndex) === true ? checkStatus(rowIndex)===true?(
                                                <>
                                                  {checkBoxData[rowIndex].enddate}
                                                </>
                                                ) : (
                                                table[tableInfo]
                                                ):(
                                                    table[tableInfo]
                                                    )}
                                            </>
                                            ) : (
                                            <></>
                                            )}                                                                                                                                                                                                                                                                                                                                                                                                                                                            
                                        </>

                                </div>
                            ) : (
                                <>
                                            {(tableInfo != "accountstatus")
                                             &&(tableInfo != "docstatus")&&(tableInfo != "trialstatus")
                                             &&(tableInfo != "trialperiod")&&(tableInfo != "substatus")&&(tableInfo != "paymentstatus") 
                                                ? table[tableInfo]
                                                : <></>}                                
                                             { tableInfo === "docstatus" ? (
                                                <>
                                                    {table[tableInfo]==""?"--":getDocumentStatus(table[tableInfo])}  
                                                </>                                                   
                                               )                                             
                                               : <></>
                                             }                                           
                                             { tableInfo === "trialstatus" ? (
                                                    <>
                                                        {table[tableInfo]==""?"--":getTrialStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               : <></>
                                             } 
                                             { tableInfo === "accountstatus" ? (
                                                    <>
                                                        {table[tableInfo]==""?"--":getAccountStatus(table[tableInfo])
                                                       }    
                                                    </> 
                                               )                                             
                                               : <></>
                                             }                                              
                                             { tableInfo === "paymentstatus" ? (
                                                    <>
                                                        { table[tableInfo]==""?"--":getPaymentStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               : <></>
                                             }                                              
                                             { tableInfo === "substatus" ?(
                                                    <>
                                                        {
                                                        table[tableInfo]==""?"--":getSubscriptionStatus(table[tableInfo])}    
                                                    </> 
                                               )                                             
                                               :<></>
                                             }                                 
                                </>
                            )}
                        </div>
                    ))}
                </div>
            ))}
            <Modal
                title="Document Viewer"
                open={isModalVisible}
                onCancel={handleModalClose}
                footer={null}
                width={800}
                style={{ top: 20 }}
                styles={{ 
                    body: {
                        padding: '20px',
                        height: '70vh',
                        overflow: 'auto'
                    }
                }}
                destroyOnHidden={true}
                maskClosable={false}
            >
                {userVerificationFile && (
                    <div style={{ 
                        textAlign: 'center',
                        // height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        {userVerificationFile.type === 'image' ? (
                            <img 
                                src={URL.createObjectURL(userVerificationFile)} 
                                alt="Document" 
                                style={{ 
                                    maxWidth: '100%', 
                                    maxHeight: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        ) : userVerificationFile.type === 'application/pdf' ? (
                            <Document 
                                file={userVerificationFile} 
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={(error) => console.error('Error loading PDF:', error)}
                            >
                                {Array.from(new Array(numPages), (_, index) => (
                                    <Page 
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1} 
                                        width={Math.min(750, window.innerWidth * 0.7)}
                                        style={{ marginBottom: '20px' }}
                                    />
                                ))}
                            </Document>
                        ) : (
                            <div>
                                <p>Document type not supported for preview</p>
                                <Button 
                                    type="primary" 
                                    onClick={() => {
                                        const url = URL.createObjectURL(userVerificationFile);
                                        const a = document.createElement('a');
                                        a.href = url;
                                        a.download = 'document.pdf';
                                        a.click();
                                        URL.revokeObjectURL(url);
                                    }}
                                >
                                    Download Document
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </Modal>
        </div>
    )
}
